import DashboardLayout from "../layouts/DashboardLayout";


const DashboardPage = () => {
  return (
    <DashboardLayout>
      <h1 className="text-2xl font-bold mb-4 text-copy-primary">Dashboard Overview</h1>
      <p className="text-copy-primary">Welcome to the dashboard. Here's a quick overview of your platform metrics:</p>
      
      {/* Example future placeholders */}
      <div className="grid grid-cols-3 gap-4 mt-6">
        <div className="bg-white p-4 shadow rounded">Total Packages</div>
        <div className="bg-white p-4 shadow rounded">Total Subscriptions</div>
        <div className="bg-white p-4 shadow rounded">Total Revenue</div>
      </div>
    </DashboardLayout>
  );
};

export default DashboardPage;
